export default "__VITE_ASSET__CjRA9cz6__"